import { SocketMatchmakingSend } from '../../../shared/scripts/socket/SocketMatchmakingSend.ts';
import { UIMatchmakingSearchMatchPopupView } from './UIMatchmakingSearchMatchPopupView.ts';
import { COLONIST_VERSION } from '@colonist/types';
import { getMatchTypeEligibilityAndCreatePopup, getMatchTypePlayerAndBotCount, isRankedMatchType } from '../../../shared/scripts/matchmaking/MatchmakingUtilsClient.ts';
import { socket } from '../../../shared/scripts/EntryShared.ts';
import { UIAdBlockController } from '../ui_ad/UIAdBlockController.ts';
import { UIUtilsEjsVariables } from '../../../shared/scripts/UIUtilsEjsVariables.ts';
import { UIVideoAdController } from '../../../shared/scripts/ui_ad/UIVideoAdController.ts';
import { ClientUserState } from '../../../shared/scripts/ClientUserState.ts';
export class UIMatchmakingFindGameController {
    init() {
        socket.controller.registerSessionEstablishedObserver(()=>{
            this.resendFindGame();
        });
    }
    resendFindGame() {
        if (SocketMatchmakingSend.delayMatchmakingTimeout != undefined) return;
        if (!this.searchMatchPopupView.isShowing()) return;
        if (!SocketMatchmakingSend.lastMatchmakingRequest) {
            this.removePopups();
            return;
        }
        SocketMatchmakingSend.sendFindGame();
    }
    updateMatchmakingStatus(matchmakingStatusUpdate) {
        if (this.selectedMatchType == undefined) return;
        this.searchMatchPopupView.update(matchmakingStatusUpdate, this.selectedMatchType);
    }
    removePopups() {
        this.searchMatchPopupView.hide();
    }
    stopSearching() {
        this.removePopups();
        SocketMatchmakingSend.sendCancelFindGame();
    }
    sendFindGameMessageToServer(selectedMatchType) {
        var _ClientUserState_userState;
        const { isEligible, createPopup } = getMatchTypeEligibilityAndCreatePopup(selectedMatchType);
        createPopup === null || createPopup === void 0 ? void 0 : createPopup();
        if (!isEligible) return;
        const matchmakingRequest = {
            clientVersion: COLONIST_VERSION,
            matchType: selectedMatchType
        };
        const adblockIsActive = this.uiManager.adController.adblockState.isAdblockActive;
        this.selectedMatchType = selectedMatchType;
        const rankedStates = this.uiManager.modeSelector.rankedStates;
        const adShown = this.videoAdController.triggerMatchmakingVideoAd(selectedMatchType, rankedStates, adblockIsActive, matchmakingRequest);
        if (adShown) return;
        const isNotPremiumUser = !((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.items.hideAds());
        const shouldShowDisableAdblockPopup = adblockIsActive && isNotPremiumUser && isRankedMatchType(selectedMatchType) && UIUtilsEjsVariables.rankedPrerollAdsEnabled;
        if (shouldShowDisableAdblockPopup) {
            const noContinueAction = ()=>undefined;
            UIAdBlockController.showDisableAdblockPopup(noContinueAction, 'nondismissible');
            this.removePopups();
            return;
        }
        const initialPopupStatus = {
            numberOfPlayersFound: 1,
            totalNumberOfPlayersNeeded: getMatchTypePlayerAndBotCount(selectedMatchType).playerCount
        };
        this.searchMatchPopupView.update(initialPopupStatus, selectedMatchType);
        SocketMatchmakingSend.enterMatchmaker(matchmakingRequest);
    }
    constructor(uiManager){
        this.uiManager = uiManager;
        this.videoAdController = new UIVideoAdController();
        this.searchMatchPopupView = new UIMatchmakingSearchMatchPopupView();
    }
}
